import { useEffect } from 'react';
import { ICON_ID } from '@gcloud-npm/utils.enums.icon-id';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import Page from '@/components/pageLayout';
import { sendTaggingInfo } from '@/utils/common';
import MetaData from '@/bit/core/core.meta-data';
import ErrorPageContent from './errorPageContent';
import { DEFAULT_ERROR_PAGE_TEXT } from './constants';

function ErrorPage({
  title = DEFAULT_ERROR_PAGE_TEXT.TITLE,
  description = DEFAULT_ERROR_PAGE_TEXT.DESCRIPTION,
  showButtons = true,
  buttonHref = DEFAULT_ERROR_PAGE_TEXT.BUTTON_HREF,
  buttonOnClick = null,
  buttonText = DEFAULT_ERROR_PAGE_TEXT.BUTTON_TEXT,
  iconId = ICON_ID.Alerta,
  iconKind = 'm',
  showIcon = true,
  iconColor = COLOR_DICTIONARY.RED,
  linkText = DEFAULT_ERROR_PAGE_TEXT.LINK_TEXT,
  linkUrl = DEFAULT_ERROR_PAGE_TEXT.LINK_URL,
  showLink = true,
  seoInfo = null,
  id = DEFAULT_ERROR_PAGE_TEXT.ERROR_ID,
  componentContent = 'none',
  isPage = true,
}) {
  useEffect(() => {
    sendTaggingInfo(
      {
        componentName: id,
        componentVariation: 'none',
        componentContent,
        componentPerso: 'none',
        componentProduct: 'none',
      },
      'print-success'
    );
  }, []);
  return (
    <>
      {seoInfo && <MetaData seoInfo={seoInfo} />}
      {isPage && (
        <Page pageId={id}>
          <div className="container stopper">
            <div className="row">
              <div className="col-start-4 col-xs-12">
                <ErrorPageContent
                  title={title}
                  description={description}
                  showButtons={showButtons}
                  buttonHref={buttonHref}
                  buttonOnClick={buttonOnClick}
                  buttonText={buttonText}
                  iconId={iconId}
                  iconColor={iconColor}
                  iconKind={iconKind}
                  showIcon={showIcon}
                  linkText={linkText}
                  linkUrl={linkUrl}
                  showLink={showLink}
                />
              </div>
            </div>
          </div>
        </Page>
      )}
      {!isPage && (
        <ErrorPageContent
          title={title}
          description={description}
          showButtons={showButtons}
          buttonHref={buttonHref}
          buttonOnClick={buttonOnClick}
          buttonText={buttonText}
          iconId={iconId}
          iconKind={iconKind}
          showIcon={showIcon}
          iconColor={iconColor}
          linkText={linkText}
          linkUrl={linkUrl}
          showLink={showLink}
        />
      )}
      <style jsx>
        {`
          .stopper {
            margin-top: auto;
            margin-bottom: auto;
          }
          :global(.stopper__title) {
            margin-top: 20px;
            margin-bottom: 16px;
          }
          :global(.stopper__icon) {
            height: 64px;
          }
          .stopper__buttons {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 16px;
            width: 100%;
            :global(.stopper__button) {
              width: 100%;
            }
            :global(.stopper__link) {
              margin-top: 16px;
            }
          }
          @media screen and (min-width: 768px) {
            .col-start-4 {
              grid-column-start: 4;
              grid-column-end: 10;
            }
            .stopper__buttons {
              display: flex;
              flex-direction: row;
              justify-content: start;
              align-items: center;
              gap: 42px;
              width: 100%;
              :global(.stopper__button) {
                width: auto;
              }
              :global(.stopper__link) {
                margin-top: 0px;
              }
            }
          }
        `}
      </style>
    </>
  );
}

export default ErrorPage;
